import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    OnDestroy,
    OnInit,
    output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EkTabsModule, EkTabButtonsComponent } from '@beta-foundations/ui-kit/panel/tabs';
import { InsegnamentoConfig, InsegnamentoItem, InsegnamentoService } from '../../services/insegnamento.service';
import { EkTabItem } from '@beta-foundations/ui-kit/types';
import { NavSubmenuConfig, NavSubmenuService } from '../../services/submenu.service';

@Component({
  selector: 'nav-submenu',
  standalone: true,
  imports: [
    CommonModule,
    EkTabsModule,
    PopoverModule,
    EkTabButtonsComponent
],
  templateUrl: './sub-menu.component.html',
  styleUrl: './sub-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavSubmenuComponent implements OnInit, OnDestroy {
  private submenuService = inject(NavSubmenuService);
  private insegnamentoService = inject(InsegnamentoService);
  private cdr = inject(ChangeDetectorRef);
  private destroy$ = new Subject<void>();
  
  selectionChange = output<string | number>();
  
  insConfig: InsegnamentoConfig | null = null;
  config: NavSubmenuConfig | null = null;
  insegnamentoSelectedValue: string | number | undefined = undefined;
  selectedValue: string | number | undefined = undefined;
  selectedItem: InsegnamentoItem | null = null;

  ngOnInit(): void {

    this.submenuService.config$
      .pipe(takeUntil(this.destroy$))
      .subscribe((config: NavSubmenuConfig | null) => {
        this.config = config;
        this.cdr.markForCheck();
      });

    this.insegnamentoService.teachingConfig$
      .pipe(takeUntil(this.destroy$))
      .subscribe((config: InsegnamentoConfig | null) => {
        this.insConfig = config;
        if (config?.defaultSelected && this.insegnamentoSelectedValue === undefined) {
          this.insegnamentoSelectedValue = config.defaultSelected;
          this.submenuService.updateSelection(config.defaultSelected); 
        }
        this.cdr.markForCheck();
      });

    this.insegnamentoService.selectedTeaching$
        .pipe(takeUntil(this.destroy$))
        .subscribe(item => {
            this.selectedItem = item;
            this.insegnamentoSelectedValue = item?.id ? String(item.id) : undefined;
            this.cdr.markForCheck(); 
        });
  }

  onTabButtonSelection(value: string | number): void {
    this.submenuService.updateSelection(value);
    this.selectionChange.emit(value);
  }

  getSelectedLabel(): string {
    return this.selectedItem?.corso || ''; 
  }

  get tabItems(): EkTabItem[] {
    if (!this.config?.items) {
      return [];
    }
    
    return this.config.items.map(item => ({
      id: item.id,
      label: item.label,
    }));
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackByItemId(index: number, item: InsegnamentoItem): string | number {
    return item.id;
  }
}
